import { Button, Grid, TextField } from "@material-ui/core"
import { useFormik } from "formik"
import * as yup from "yup"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch } from "react-redux"
import { actulizarLandingAction, actulizarlandingFormAction, crearLandingAction, obtenerLandingAllAction, obtenerLandingHabilitadosAction, targetLandingObjetoAction } from "./../../../ducks/landingDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { makeStyles } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useEffect } from "react"

export const FormularioReservaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "100%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const validationSchema = yup.object({
    descripcion: yup
        .string("Ingresa una descripcion")
        .required("Descripcion es requerido"),
    nombre: yup
        .string("Ingresa un nombre")
        .required("Nombre es requerido"),
})

const initialValues = {
    nombre: "",
    descripcion: ""
}

const FormLanding = () => {
    const dispatch = useDispatch()
    const classes = FormularioReservaStyle()
    const { actulizar, landingObj } = useSelector(store => store.landing)
    console.log("🚀 ~ FormLanding ~ landingObj:", landingObj)
    console.log("🚀 ~ FormLanding ~ actulizar:", actulizar)
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            (actulizar) ? onUpdate(values) : onSave(values)
        },
    })
    useEffect(() => {
        formik.setFieldValue("nombre", landingObj?.Nombre)
        formik.setFieldValue("descripcion", landingObj?.Descripcion)
    }, [landingObj?.IdLanding])
    const onCancelar = () => {
        dispatch(actulizarlandingFormAction({actulizar: false}))
        dispatch(targetLandingObjetoAction({landing: {}}))
    }
    const onUpdate = (values) => {
        dispatch(onLoadAnction({ message: "" }))
        const payload = {
            IdLanding: landingObj?.IdLanding,
            Descripcion: values.descripcion,
            Enlace: `/${values.nombre.replace(" ", "").trim().toLowerCase()}`,
            Nombre: values.nombre,
            Slug: values.nombre.replace(" ", "-").trim().toLowerCase()
        }
        dispatch(actulizarLandingAction(payload)).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            dispatch(obtenerLandingAllAction())
            dispatch(obtenerLandingHabilitadosAction())
            onCancelar()
            formik.resetForm(initialValues)
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            })

        })

    }
    const onSave = (values) => {
        dispatch(onLoadAnction({ message: "" }))
        const payload = {
            Descripcion: values.descripcion,
            Enlace: `/${values.nombre.replace(" ", "").trim().toLowerCase()}`,
            Nombre: values.nombre,
            Slug: values.nombre.replace(" ", "-").trim().toLowerCase()
        }
        dispatch(crearLandingAction(payload)).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            onCancelar()
            dispatch(obtenerLandingAllAction())
            dispatch(obtenerLandingHabilitadosAction())
            formik.resetForm(initialValues)
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            })

        })
    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <TextField
                        required
                        id="input-nombre-landing-new"
                        label="Nombre"
                        type="text"
                        variant="outlined"
                        name="nombre"
                        value={formik.values.nombre}
                        onChange={formik.handleChange}
                        error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                        helperText={formik.touched.nombre && formik.errors.nombre}
                        className={classes.textField}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        required
                        id="input-descripcion-landing-new"
                        label="Descripcion"
                        type="text"
                        variant="outlined"
                        name="descripcion"
                        value={formik.values.descripcion}
                        onChange={formik.handleChange}
                        error={formik.touched.descripcion && Boolean(formik.errors.descripcion)}
                        helperText={formik.touched.descripcion && formik.errors.descripcion}
                        className={classes.textField}
                    />
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    {
                        (actulizar) &&
                        <Button
                            variant="contained"
                            color="default"
                            className={classes.modalBoton}
                        >
                            Cancelar
                        </Button>
                    }
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={onCancelar}
                    >
                        {
                            (actulizar) ? "Actulizar" : "Guardar"
                        }
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
export default FormLanding